const set = (state, { payload }) => {
	state.action = payload;
};

const reset = (state) => {
	state.action = null;
};

export { set as setAction, reset as resetAction };
